import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  descriptionStyle: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
    fontWeight: 'lighter',
    fontSize: 12,
  },
  informationStyle: {
    marginBottom: theme.spacing(4),
    marginLeft: theme.spacing(3),
    fontSize: 18,
  },
  titleStyle: {
    margin: theme.spacing(3, 3),
  },
  textFieldStyle: {
    marginTop: theme.spacing(5),
  },
  buttonLink: {
    margin: theme.spacing(0),
    textTransform: 'none',
  },
}))

export default useStyles
